module.exports = __webpack_public_path__ + "img/sx.dd2e817b.png";